import React from "react";
import { Table } from "components";
import PropTypes from "prop-types";
import { Row, Col, Button } from "antd";
import { List, OrderedMap, Map } from "immutable";
import { onCellGenerator } from "constants/table-columns";
import { TABLE_DATA_TYPES } from "constants/table-data-types";

const PSKIT_COURIER_COLS = new OrderedMap({
    name: {
        title: "Name",
        dataIndex: "name",
        key: "name",
        editable: false,
        onCellGenerator,
        dataType: TABLE_DATA_TYPES.STRING
    },
    pod_no: {
        title: "POD No",
        dataIndex: "pod_no",
        key: "pod_no",
        editable: true,
        dataType: TABLE_DATA_TYPES.STRING,
        onCellGenerator
    },
    date: {
        title: "Date",
        dataIndex: "date",
        key: "date",
        editable: true,
        dataType: TABLE_DATA_TYPES.STRING,
        onCellGenerator
    },
    courier_company: {
        title: "Courier Company",
        dataIndex: "courier_company",
        key: "courier_company",
        editable: false,
        onCellGenerator
    },
});

class PskitCourierDetailsPage extends React.Component {

    state = {
        updatedPodDetails: new Map({})
    };  

    componentDidMount() {
        // this.props.fetchSellerLedgerMaster(this.props.companyId);
    }

    updateLedgerEntries = () => {
        // if(this.state.updatedPodDetails && this.state.updatedPodDetails.size) {
        //     this.props.updatePskitCourierDetails(this.state.updatedPodDetailsprops.companyId, this.state.updatedPodDetails.toList().toArray());
        // }
    }

    handleSaveMultipleEntries = (record, values) => {
        this.setState({
            updatedPodDetails: this.state.updatedPodDetails.set(record.id, {
                id: record.id,
                ...values
            })
        });
    }

    onFilter = (values) => {
        this.filterObj = {};
        new Map(values).map((_, k) => {
            this.filterObj[k] = _ && _[0];
        });
        this.props.fetchSellerLedgerMaster(this.props.companyId, this.filterObj);
    }

    render() {
        return (
            <Row>
                <Col offset={3} span={18} className={"mb-10"}>
                    <Table
                        title={<span style={{fontWeight: "bold", fontSize: "16px"}}>
                            {"Pskit Courier Details"}
                        </span>}
                        showFilters={true}
                        columns={PSKIT_COURIER_COLS.map(({ onCellGenerator, editable, ...restColFields}) => {
                            if (!onCellGenerator || !editable) {
                                return { ...restColFields };
                            }
                            return {
                                onCell: onCellGenerator(
                                    this.handleSaveMultipleEntries,
                                    restColFields
                                ),
                                ...restColFields
                            };
                        })}
                        spanConfig={{
                            title: 6,
                            filters: 10,
                            btnSpan: 8
                        }}
                        showTopSection={true}
                        noRowSelection={true}
                        data={(this.props.sellerLedgerMasters && this.props.sellerLedgerMasters.toList()) || new List([])}
                        editable={true}
                        pagination={false}
                        onFilter={this.onFilter}
                        tablePagination={true}
                    />
                </Col>
                <Col offset={3} span={18} className={"d-flex flex-row-reverse"}>
                    <Button type={"primary"} onClick={this.updateLedgerEntries}>
                        Update
                    </Button>
                </Col>
            </Row>
        );
    }

}

PskitCourierDetailsPage.propTypes = {
    companyId: PropTypes.number,
    updatePskitCourierDetails: PropTypes.func,
    sellerLedgerMasters: PropTypes.func,
    fetchSellerLedgerMaster: PropTypes.func,

};

export default PskitCourierDetailsPage;